import {Button, Pagination, Row, Table, Tooltip} from "antd";
import React, {useEffect, useState} from "react";
import api from "./store/api"
import {useDispatch} from "react-redux";
import StatisticModal from "./statisticModal";
import PriceTree from "./priceTree";
import PtmTree from "./ptmTree";
import {useTranslation} from "react-i18next";
import {clearCompareObjectAction, getMinMaxCostsAction, getSummaryCostsAction} from "../ProjectLibrary/store/actions";
import CompareForm1 from "../ProjectLibrary/CompareForm/CompareForm1";
import CompareForm2 from "../ProjectLibrary/CompareForm/CompareForm2";

const ObjectAnalogTable = (props) => {
    const {stateFuncType, project, setProject, formState, viewBlock, setViewBlock, titleForTable} = props
    const [loading, setLoading] = useState(false)
    const [isStatisticVisible, setIsStatisticVisible] = useState(false)
    const [selectedRows, setSelectedRows] = useState([]);
    const [objects, setObjects] = useState(null)
    const [objectPtm, setObjectPtm] = useState(null)
    const [objectPrice, setObjectPrice] = useState(null)
    const [ptmVisible, setPtmVisible] = useState(false)
    const [pricesVisible, setPricesVisible] = useState(false)
    const dispatch = useDispatch()
    const {t} = useTranslation(['common', 'action'])
    const hasSelected = selectedRows.length > 0;

    const columns = [
        {
            key: 'name',
            title: 'Название',
            dataIndex: 'name',
        },
        {
            key: 'code',
            title: 'Код',
            dataIndex: 'code',
            align: 'center'
        },
        {
            key: 'zone',
            title: t('common:zone'),
            dataIndex: 'zoneCode',
            align: 'center',
            width: '3%'
        },
        {
            key: 'region',
            title: t('common:region'),
            dataIndex: 'regionName',
            align: 'center',
            width: '9%'
        },
        {
            key: titleForTable.data,
            title: titleForTable.title,
            dataIndex: titleForTable.data,
            align: 'center',
        },
        {
            key: 'power',
            title: 'Выходная мощность',
            dataIndex: 'power',
            align: 'center'
        },
        {
            key: 'unit',
            title: 'Единица измерения',
            dataIndex: 'reMeasurementUnitName',
            align: 'center'
        },
        {
            key: 'price',
            title: 'Стоимость',
            dataIndex: 'price',
        },
        {
            title: 'ПТМы',
            key: 'operation',
            fixed: 'right',
            align: 'center',
            width: 100,
            render: (record) => <div style={{}}>
                <Tooltip title={'Список всех ПТМ данного объекта'}><a
                    onClick={() => showPtm(record)}>список</a></Tooltip>
            </div>
        },
        /*{
            title: 'Сметы',
            key: 'operation',
            fixed: 'right',
            align: 'center',
            width: 100,
            render: (record) => <div style={{}}>
                <Tooltip title={'Список всех смет данного объекта'}><a
                    onClick={() => showPrices(record)}>список</a></Tooltip>
            </div>
        }*/
    ];

    useEffect(_ => {
        getPageProjectByCode(1, 20)
        setSelectedRows([])
    }, [stateFuncType])


    const getPageProjectByCode = (page, pageSize) => {
        (async _ => {
                if (stateFuncType) {
                    setLoading(true)
                    let rs = null
                    const ft = stateFuncType
                    if (ft.code3 === '00') {
                        rs = await api.getPageObjectByCode2({code1: ft.code1, code2: ft.code2, page, pageSize});
                    } else if (ft.code4 === '00') {
                        rs = await api.getPageObjectByCode3({
                            code1: ft.code1,
                            code2: ft.code2,
                            code3: ft.code3,
                            page,
                            pageSize
                        });
                    } else {
                        rs = await api.getPageObjectByCode4({
                            code1: ft.code1, code2: ft.code2,
                            code3: ft.code3, code4: ft.code4,
                            page,
                            pageSize
                        });
                    }
                    if (rs) {
                        setObjects(rs)
                    }
                    setLoading(false)
                }
            }
        )()
    }

    const onChange = (page, pageSize) => {
        getPageProjectByCode(page, pageSize)
    };

    const showPrices = (record) => {
        setPricesVisible(true)
        setObjectPrice(record)
    }

    const showPtm = (record) => {
        setPtmVisible(true)
        setObjectPtm(record)
    }

    const rowSelection = {
        onSelect: (record, selected) => {
            //let index = data.findIndex((obj => obj.id === record.id));
            let selectedKeys
            if (selected) {
                selectedKeys = [...selectedRows]
                selectedKeys.push(record)
            } else {
                selectedKeys = selectedRows.filter(n => n.key !== record.key)
            }
            setSelectedRows(selectedKeys)
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            let keys = selectedRows
            setSelectedRows(keys)
        },
        hideSelectAll: false,
        //columnTitle: 'Выбор'
    };

    const statistics = () => {
        setIsStatisticVisible(true)
    };

    return (
        <div className='object-analog-table-div'>
            {viewBlock === "default" ?
                <>
                    <div style={{display: 'flex', gap: '16px', marginBottom: 16}}>
                        <Button type="primary" onClick={statistics} disabled={!hasSelected}>
                            Показать статистику
                        </Button>
                        {hasSelected ? <>
                                <Button
                                    onClick={() => {
                                        let ids = selectedRows.map(n => n.id)
                                        dispatch(getSummaryCostsAction({analogObjectIds: ids}))
                                        setViewBlock("compareForm1")
                                    }}
                                >
                                    Сравнить по форме 1
                                </Button>
                                <Button
                                    onClick={() => {
                                        let ids = selectedRows.map(n => n.id)
                                        dispatch(getMinMaxCostsAction({analogObjectIds: ids}))
                                        setViewBlock("compareForm2")
                                    }}
                                >
                                    Сравнить по форме 2
                                </Button>
                                <Button
                                    type="default"
                                    onClick={() => {
                                        dispatch(clearCompareObjectAction())
                                        setSelectedRows([])
                                    }
                                    }
                                >
                                    Сбросить
                                </Button>
                            </>
                            : null}
                    </div>

                    <Table
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                            selectedRowKeys: selectedRows.map(n => n.key)
                        }}
                        loading={loading}
                        columns={columns}
                        dataSource={objects?.items.map((el, idx) => ({key: el.id, ...el}))}
                        pagination={false}
                        size="middle"
                    />
                    {objects &&
                        <Row justify={'end'} style={{padding: '20px 0'}}>
                            <Pagination
                                current={objects.page}
                                pageSize={objects.pageSize}
                                total={objects.count}
                                showTotal={total => `Всего ${total} объект(ов)`}
                                showSizeChanger
                                onChange={onChange}
                            />
                        </Row>
                    }
                </>
                : null}
            {viewBlock === "compareForm1" ?
                <CompareForm1
                    setViewBlock={setViewBlock}
                />
                : null}
            {viewBlock === "compareForm2" ?
                <CompareForm2
                    setViewBlock={setViewBlock}
                />
                : null}
            <StatisticModal
                stateFuncType={stateFuncType}
                selectedRows={selectedRows}
                isStatisticVisible={isStatisticVisible}
                setIsStatisticVisible={setIsStatisticVisible}
            />
            <PtmTree
                visible={ptmVisible}
                setVisible={setPtmVisible}
                formState={formState}
                object={objectPtm}
                project={project}
                setProject={setProject}
            />
            <PriceTree
                visible={pricesVisible}
                setVisible={setPricesVisible}
                object={objectPrice}
                setProject={setProject}
            />
        </div>
    )
}

export default ObjectAnalogTable
